<ng-container *ngIf="!hideComponent">
  <div *ngFor="let errorMessage of errorMessages" class="invalid-feedback d-block">
    {{ errorMessage }}
  </div>
</ng-container>
